import React from 'react';
import {
  Paper,
  Typography,
  Collapse,
  LinearProgress,
  IconButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ProfilerStats from '../components/ProfilerStats';

const JobDisplayer = ({
  job,
  isExpanded,
  onToggle,
  timeAgo,
  formatSeconds
}) => {
  const lastUpdateDate = new Date(job.lastupdate);
  const isStale = (Date.now() - lastUpdateDate.getTime()) > 5 * 60 * 1000;
  const isDone = job.ended != null;

  const color = job.error != null
    ? '#882222'
    : isDone
    ? '#228822'
    : isStale
    ? '#888'
    : 'background.paper';

  const borderColor = job.error != null
    ? '1px solid red'
    : isDone
    ? '1px solid green'
    : isStale
    ? '1px solid grey'
    : 'none';

  return (
    <Paper
      key={job.id}
      elevation={3}
      sx={{ p: 2, mb: 2, backgroundColor: color, border: borderColor }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {job.error && <Typography variant="subtitle1">{job.error}</Typography>}
        <Typography
          variant="subtitle1"
          sx={{ cursor: 'pointer' }}
          onClick={() => onToggle(job.id)}
        >
          {job.name} ({job.id}) — (Start: {job.started} ({timeAgo(job.started)}) - last update: {timeAgo(job.lastupdate)})
        </Typography>
        <IconButton size="small" onClick={() => onToggle(job.id)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </div>

      <Collapse in={isExpanded}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {job.description}
        </Typography>

        {job.extra && typeof job.extra === 'object' && (
          <ProfilerStats stats={job.extra} />
        )}

        <LinearProgress
          variant="determinate"
          value={job.progress_percent || 0}
          sx={{ height: 20, borderRadius: 1, mb: 1 }}
        />
        <LinearProgress
          variant="determinate"
          value={job.sub_progress_percent || 0}
          sx={{ height: 15, borderRadius: 1, mb: 1 }}
        />
        <Typography variant="caption">
          {job.progress_percent}% — Elapsed: {formatSeconds(job.elapsed_seconds)} — ETA: {formatSeconds(job.eta_seconds)}
        </Typography>
      </Collapse>
    </Paper>
  );
};

export default JobDisplayer;
